import {Alert, Backdrop, Button, CircularProgress, Grid, Snackbar, Typography} from "@mui/material";
import {useState} from "react";

export const useCargador = ({
                                logoRedondo,
                                key,
                                funcionUno = () => {
                                },
                                funcionDos = () => {
                                }

                            }) => {
    const [open, setOpen] = useState(false)
    const [openAviso, setOpenAviso] = useState(false)
    const [proceso, setProceso] = useState(true)
    const [detener, setDetener] = useState(false)
    const [mensaje, setMensaje] = useState('')
    const [hayBoton, setHayBoton] = useState(false)
    const [variante, setVariante] = useState('succes')

    const iniciarCarga = (proceso = ['Subiendo datos']) => {
        setOpen(true)
        setProceso(proceso)
    }

    const cerrarCarga = () => {
        setDetener(false)
        setOpen(false)
    }

    const terminarAvisos = () => {
        if (funcionUno !== null) {
            funcionUno()
        }
        if (funcionDos !== null) {
            funcionDos()
        }

        setOpen(false)
        setOpenAviso(false)
    }

    const nuevoAviso = ({aviso, variante = 'success', Boton}) => {
        setMensaje(aviso)
        setVariante(variante)
        setOpenAviso(true)
    }

    const terminar = ({aviso = 'Tarea Finalizada', variante = 'success'}) => {
        setMensaje(aviso)
        setVariante(variante)
        setOpenAviso(true)
        setHayBoton(true)
        setDetener(true)
    }

    const Cargador = () => {


        return (

            <Backdrop
                open={open}
                sx={(theme) => ({color: '#fff', zIndex: theme.zIndex.drawer + 1})}
            >
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                        <img src={logoRedondo} width={100} height={'auto'} className={detener ? '' : 'cargando'}
                             alt={'Logo de la empresa'} title={'Logo'}/>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 2}}>

                        <Typography sx={{
                            color: '#fff',
                            marginTop: -0.5,
                            pr: detener ? 0 : 1,
                            textAlign: 'center'
                        }}>{detener ? '' : proceso}</Typography>

                        {detener ? '' :
                            <CircularProgress size={20}/>
                        }


                    </Grid>


                </Grid>


            </Backdrop>

        )
    }

    const Avisos = () => {


        const verificarBoton = () => {
            if (hayBoton) {
                return <Button
                    variant={"text"}
                    onClick={() => terminarAvisos()}
                    sx={{color: '#fff', py: 0.2}}
                >
                    Entendido
                </Button>
            } else {
                return ''
            }
        }

        const obtenerColor = () => {

            if (variante === 'error') {
                return '#DA3D32'
            }

            return '#5EAC61'
        }

        return (
            <Snackbar
                key={key}
                open={openAviso}
                onClose={() => setOpen(false)}
            >
                <Alert
                    severity={variante}
                    variant="filled"
                    sx={{minWidth: 250, backgroundColor: obtenerColor(), borderRadius: 2}}
                    action={verificarBoton(hayBoton)}
                >
                    {mensaje}
                </Alert>
            </Snackbar>
        )
    }

    return {
        Avisos,
        Cargador,
        iniciarCarga,
        cerrarCarga,
        nuevoAviso,
        terminar

    }

}